// ═══════════════════════════════════════════════════════════════
// billingApi.js — Abonnements Stripe (chantier #5 / backend #1)
// ═══════════════════════════════════════════════════════════════

const getToken = () => localStorage.getItem('oracle_token');

const headers = () => ({
    'Authorization': `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
});

async function post(path, body) {
    const res = await fetch(path, { method: 'POST', headers: headers(), body: body ? JSON.stringify(body) : undefined });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}

// Démarre un abonnement → redirige vers Stripe Checkout.
export async function startCheckout(tier) {
    const { url } = await post('/api/billing/checkout', { tier });
    if (url) window.location.href = url;
    return url;
}

// Ouvre le portail Stripe (gérer / annuler).
export async function openPortal() {
    const { url } = await post('/api/billing/portal');
    if (url) window.location.href = url;
    return url;
}
